import { route } from 'react-router-typesafe-routes/dom';

export const railwayAppRoute = route('');

export const terminalsAppRoute = route('terminals');
